<template>
  <v-container fluid class="fill-height bg-grey-lighten-4">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="10" md="10" lg="12" xl="8">
        <!-- Título centrado -->
        <h2 class="text-h4 font-weight-bold mb-2 text-center">
          Nuestros Servicios
        </h2>

        <!-- Subrayado naranja centrado -->
        <v-divider
          class="mx-auto mb-6"
          color="orange"
          style="width: 60px; height: 4px;"
        />
        <router-view/>

        <!-- Back to Home -->
        <div class="text-center mt-6 mb-6">
          <v-btn
            to="/"
            variant="text"
            color="grey-darken-1"
            prepend-icon="mdi-arrow-left"
          >
            Volver al inicio
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const activeTab = ref(route.path)

watch(route, (r) => {
  activeTab.value = r.path
})
</script>
<style lang="">
    
</style>